<template>
	<div class="menu">
		<img @click="hiddenMobile" class="menu-img" src="../../public/images/close.png" alt="">
		<div class="menu-c">
			<div class="item" v-for="(item, index) in list" :key="index" @click="taplist(index, item)">
				<div v-if="index >= 9" class="sore">{{index+1}}</div>
				<div v-else class="sore">0{{index+1}}</div>
				
				<div class="line"></div> {{item.name}}
			</div> 
		</div>
	</div>
</template>

<script>
	
	export default {
		props:{
			
		},
		data() {
			return {
				list: [{
						name: "首页",
						key: "index",
						path:"/index"
					},
					{
						name: "关于我们",
						key: "about",
						path:"/about"
					},
					{
						name: "业务与服务",
						key: "service",
						path:"/service"
					},
					{
						name: "应用场景",
						key: "product",
						path:"/product"
					},
					{
						name: "项目案例",
						key: "case",
						path:"/case"
					},
					{
						name: "新闻媒体",
						key: "medium",
						path:"/medium"
					},
					{
						name: "下载中心",
						key: "download",
						path:"/download"
					},
					{
						name: "联系我们",
						key: "contactus",
						path:"/contactus"
					},
					{
						name: "招贤纳士",
						key: "hire",
						path:"/hire"
					},
					{
						name: "EN",
						enname:"EN",
						key: "/en",
						path:"/en"
					},
				
				],

			}
		},
		watch:{
			
		},
		created() {

		},
		methods: {
			taplist(index, item) {
				if(item.key == 'en') {
					var currentURL = window.location.href;
					if (currentURL.includes("index")) {
					    this.$router.push("/en")
					}else if (currentURL.includes("about")) {
					    this.$router.push("/en/about")
					}else if (currentURL.includes("service")) {
					    this.$router.push("/en/service")
					}else if (currentURL.includes("product")) {
					    this.$router.push("/en/product")
					}else if (currentURL.includes("case")) {
					    this.$router.push("/en/case")
					}else if (currentURL.includes("medium")) {
					    this.$router.push("/en/medium")
					}else if (currentURL.includes("download")) {
					    this.$router.push("/en/download")
					}else if (currentURL.includes("contactus")) {
					    this.$router.push("/en/contactus")
					}else if (currentURL.includes("hire")) {
					    this.$router.push("/en/hire")
					}else {
					    this.$router.push("/en")
					}
				}else if(item.key == 'index'){
					this.$router.push("/")
				}else {
					this.$router.push(item.key)
				}
			},
			hiddenMobile(){
				this.$emit("hiddenMobile", {})
			}
		}
	}
</script>

<style lang="scss">
	.menu {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 1);
		z-index: 99999;
		
		.menu-img {
			position: absolute;
			top: 40px;
			right: 40px;
			width: 20px;
			height: 20px;
		}
		.menu-c {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.item {
				width: 100%;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				color: #f9f9f9;
				font-size: 15px;
				margin-top: 20px;
				.sort {
					
				}
				.line {
					width: 40px;
					height: 1px;
					margin-left: 10px;
					margin-right: 10px;
					background-color: #f9f9f9;
				}
			}
		}
		
	}
	
	@media screen and (min-width: 1200px) {
		.menu {
			display: none;
		}
	
	}
	@media screen and (max-width: 1200px) {
		.menu {
			display: block;
		}
	  
	}
	@media screen and (max-width: 880px) {
		.menu {
			display: block;
		}
	  
	}
</style>
